import { render, staticRenderFns } from "./Post_Section_Image.vue?vue&type=template&id=148a1ace&scoped=true&"
import script from "./Post_Section_Image.vue?vue&type=script&lang=js&"
export * from "./Post_Section_Image.vue?vue&type=script&lang=js&"
import style0 from "./Post_Section_Image.vue?vue&type=style&index=0&id=148a1ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a1ace",
  null
  
)

export default component.exports